import React from "react";
import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";

// ============================================================================
// BusyButton — tombol kirim-ke-server standar ETAMSIOS (#4b-1, STANDAR_UI D1).
//
// D1 menuntut DUA-DUANYA, bukan salah satu:
//   1. Tombol langsung nonaktif begitu diklik (anti klik ganda), dan
//   2. Spinner tampil selama menunggu respons.
// Sebelum #4b-1: 12/13 tombol mutasi purchasing hanya punya disabled,
// 0/13 punya spinner, dan tombol hapus vendor tidak punya keduanya.
//
// Pemakaian: ganti <Button disabled={busy}> dengan <BusyButton busy={busy}>.
// `busyText` opsional (D3 — proses lama diberi teks penjelas, mis.
// "Menyimpan..."); tanpa busyText, label asli tetap tampil di samping spinner.
// ============================================================================

export function BusyButton({ busy, disabled, busyText, children, ...props }) {
  return (
    <Button disabled={!!busy || !!disabled} aria-busy={!!busy} {...props}>
      {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden="true" />}
      {busy && busyText ? busyText : children}
    </Button>
  );
}

export default BusyButton;
